module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori@2x-f832a0db4f5a2cdf1612a516161107d5.webp";